import type { ApprovalStage } from '@/types/workflow'

const APPROVAL_STAGE_LABELS: Record<ApprovalStage, string> = {
  proposal: '方案',
  script: '剧本',
  storyboard: '分镜',
  final: '成片',
}

const PREVIOUS_APPROVAL_STAGE: Record<ApprovalStage, ApprovalStage> = {
  proposal: 'proposal',
  script: 'proposal',
  storyboard: 'script',
  final: 'storyboard',
}

const NEXT_APPROVAL_STAGE: Record<ApprovalStage, ApprovalStage | null> = {
  proposal: 'script',
  script: 'storyboard',
  storyboard: 'final',
  final: null,
}

export function getApprovalStageDisplayLabel(stage: ApprovalStage) {
  return APPROVAL_STAGE_LABELS[stage]
}

export function getPreviousApprovalStage(stage: ApprovalStage): ApprovalStage {
  return PREVIOUS_APPROVAL_STAGE[stage]
}

export function getNextApprovalStage(stage: ApprovalStage): ApprovalStage | null {
  return NEXT_APPROVAL_STAGE[stage]
}

export function getRevisionActionLabel(stage: ApprovalStage) {
  const targetStage = getPreviousApprovalStage(stage)
  if (targetStage === stage) {
    return `重新生成${getApprovalStageDisplayLabel(stage)}`
  }
  return `返回${getApprovalStageDisplayLabel(targetStage)}修改`
}

export function getApprovalFeedbackPlaceholder(stage: ApprovalStage) {
  const nextStage = getNextApprovalStage(stage)
  const previousStage = getPreviousApprovalStage(stage)
  const approveHint = nextStage
    ? `通过时可补充进入${getApprovalStageDisplayLabel(nextStage)}阶段必须遵守的要求。`
    : '通过时可补充最终交付确认口径与验收备注。'
  const reviseHint = previousStage === stage
    ? `若要重新生成${getApprovalStageDisplayLabel(stage)}，请写清需要调整的重点。`
    : `若要退回${getApprovalStageDisplayLabel(previousStage)}阶段，请写清为什么必须回退以及要改什么。`
  return `${approveHint}${reviseHint}`
}